import { StyledSkipToContent } from './SkipToContent.styles';
import Button from '@atoms/Button/Button';
import { useState } from 'react';
import Config from '@config';

interface Props {
  buttonText: string;
  targetElementSelector: string;
  focusLast?: boolean; // Optional prop to focus the last element instead of the first
}

const SkipToContent = ({ buttonText, targetElementSelector, focusLast }: Props) => {
  const [isFocused, setIsFocused] = useState(false);

  const onClick = () => {
    const element = document.querySelector(targetElementSelector);
    if (element) {
      // Select all focusable elements within the target element
      const focusableElements = element.querySelectorAll<HTMLAnchorElement>(Config.SELECTORS.focusableElements);

      // Focus the first focusable element, if any
      if (focusableElements.length > 0) {
        focusLast ? focusableElements[focusableElements.length - 1].focus() : focusableElements[0].focus();
      }
    }
  };

  return (
    <StyledSkipToContent $isFocused={isFocused} role="navigation">
      <Button variant="primary" onClick={onClick} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)}>
        {buttonText}
      </Button>
    </StyledSkipToContent>
  );
};

export default SkipToContent;
